import React from 'react'
import { KTSVG } from '../../../../template/_metronic/helpers'

type Props = {
  title: string
  subtitle: string
  icon?: boolean
}

export const BatchCardHeader = ({title, subtitle, icon = false}: Props) => {
  return (
    <div className='d-flex flex-stack mb-9'>
      <div className='d-flex align-items-center'>
        {icon && (
          <div className='me-5'>
            <div className='symbol symbol-50px symbol-circle'>
              <span className='symbol-label bg-primary'>
                <KTSVG path='/media/soyfri-media/calendar-clock.svg' className='svg-icon-4x' />
              </span>
            </div>
          </div>
        )}
        <div className='d-flex justify-content-start flex-column'>
          <span className='fw-semibold text-primary-dark fs-2'>{title}</span>
          <span className='fw-semibold text-gray fs-3'>{subtitle}</span>
        </div>
      </div>
    </div>
  )
}
